// extracted by mini-css-extract-plugin
export default {"plannedDeliveryWindows":"planned-delivery-windows_plannedDeliveryWindows__JR946","extraContent":"planned-delivery-windows_extraContent__TUFX5"};